module.exports = {
  /*
   * 标题
   */
  title: '中国瓷博物馆-千秋德化陶瓷展',

  /*
   * 简述
   */
  showResume: false,

  resume: {
    title: '中国瓷博物馆-千秋德化陶瓷展',
    desc: ''
  },

  /*
   * 联系人
   */

  showPhone: false,

  phone: {
    name: '',
    desc: '',
    address: ''
  },

  /*
   * 文件地址
   */
  appUrl: '93vr.com',

  /*
   * 子级目录文件名
   */
  publicPath: '/dehuaguan',

  /*
   * 是否开启 https
   */
  https: true,

  /*
   * PHP访问地址
   */
  apiUrl: 'php/new.php',

  /*
   * ifrmae访问地址
   */
  iframeUrl: '//my.93vr.com/show/index2.html?m=nHQSquvdqQy&help=0&play=1&qs=1&gt=0&hr=0',
  /*
   * 背景音乐访问地址
   */
  defaultMusic: '//matcdn.93vr.com/dehuaguan/bgmusic/bg.mp3',

  /*
   * 图标访问地址
   */
  defaultIcon: '',

  /*
   * 模型访问地址
   */
  defalutModel: '',

  /*
   * 封面状态
   */
  showthumb: true,

  /*
   * 封面 PC端
   */
  thumbPC: '//matcdn.93vr.com/dehuaguan/assets/thumb.jpg',

  /*
   * 封面 移动端
   */
  thumbMobile: '//matcdn.93vr.com/dehuaguan/assets/thumbMobile.jpg',

  bgmusic: {
    0: '//matcdn.93vr.com/dehuaguan/bgmusic/1.mp3',
    1: '//matcdn.93vr.com/dehuaguan/bgmusic/2.mp3',
    2: '//matcdn.93vr.com/dehuaguan/bgmusic/3.mp3',
    3: '//matcdn.93vr.com/dehuaguan/bgmusic/4.mp3',
    4: '//matcdn.93vr.com/dehuaguan/bgmusic/5.mp3',
    5: '//matcdn.93vr.com/dehuaguan/bgmusic/6.mp3',
    6: '//matcdn.93vr.com/dehuaguan/bgmusic/7.mp3',
    7: '//matcdn.93vr.com/dehuaguan/bgmusic/8.mp3',
    8: '//matcdn.93vr.com/dehuaguan/bgmusic/9.mp3',
    9: '//matcdn.93vr.com/dehuaguan/bgmusic/10.mp3',
    10: '//matcdn.93vr.com/dehuaguan/bgmusic/11.mp3',
    11: '//matcdn.93vr.com/dehuaguan/bgmusic/12.mp3',
    12: ''
  },

  hotDatas: {
    '14rk5EWGsIt': {
      type: 'image',
      title: '清代白釉骑兽观音雕塑',
      images: ['//matcdn.93vr.com/dehuaguan/img/14rk5EWGsIt.jpg'],
      music: '',
      desc: ''
    },
    '1gEbGCAUFJP': {
      type: 'image',
      title: '现代白釉日月同辉系列雕塑',
      images: ['//matcdn.93vr.com/dehuaguan/img/1gEbGCAUFJP.jpg'],
      music: '',
      desc: ''
    },
    '3ypaDcNU92z': {
      type: 'image',
      title: '民国白釉八仙八卦纹花觚',
      images: ['//matcdn.93vr.com/dehuaguan/img/3ypaDcNU92z.jpg'],
      music: '',
      desc: ''
    },
    '41KU043kv8q': {
      type: 'image',
      title: '明代酱釉五供',
      images: ['//matcdn.93vr.com/dehuaguan/img/41KU043kv8q.jpg'],
      music: '',
      desc: ''
    },
    '4CsFcM8jEfN': {
      type: 'image',
      title: '清代白釉文昌帝君雕塑',
      images: ['//matcdn.93vr.com/dehuaguan/img/4CsFcM8jEfN.jpg'],
      music: '',
      desc: ''
    },
    '6DZl32ELwpm': {
      type: 'image',
      title: '清代克拉克盘',
      images: ['//matcdn.93vr.com/dehuaguan/img/6DZl32ELwpm.jpg'],
      music: '',
      desc: ''
    },
    '8J0n5Y4RHKt': {
      type: 'image',
      title: '清代白釉堆贴蟠螭胆瓶',
      images: ['//matcdn.93vr.com/dehuaguan/img/8J0n5Y4RHKt.jpg'],
      music: '',
      desc: ''
    },
    dG5uND5RAoh: {
      type: 'image',
      title: '清代白釉麻姑献寿雕塑',
      images: ['//matcdn.93vr.com/dehuaguan/img/dG5uND5RAoh.jpg'],
      music: '',
      desc: ''
    },
    e6hrv2CHjfj: {
      type: 'image',
      title: '现代加彩持莲观音雕塑',
      images: ['//matcdn.93vr.com/dehuaguan/img/e6hrv2CHjfj.jpg'],
      music: '',
      desc: ''
    },
    EFJPewtY6N6: {
      type: 'image',
      title: '清代青花山水纹簋式炉',
      images: ['//matcdn.93vr.com/dehuaguan/img/EFJPewtY6N6.jpg'],
      music: '',
      desc: ''
    },
    fPU9KuzoSm1: {
      type: 'image',
      title: '清代白釉梅花纹盖罐',
      images: ['//matcdn.93vr.com/dehuaguan/img/fPU9KuzoSm1.jpg'],
      music: '',
      desc: ''
    },
    isglvEDM6d2: {
      type: 'image',
      title: '元代白釉印花军持',
      images: ['//matcdn.93vr.com/dehuaguan/img/isglvEDM6d2.jpg'],
      music: '',
      desc: ''
    },
    k78I7yaJtoO: {
      type: 'image',
      title: '清代青花山水人物纹瓶',
      images: ['//matcdn.93vr.com/dehuaguan/img/k78I7yaJtoO.jpg'],
      music: '',
      desc: ''
    },
    KHB0tXruzM7: {
      type: 'image',
      title: '现代白釉寿星雕塑',
      images: ['//matcdn.93vr.com/dehuaguan/img/KHB0tXruzM7.jpg'],
      music: '',
      desc: ''
    },
    mgMnv0t0PXn: {
      type: 'image',
      title: '清代白釉达摩雕塑',
      images: ['//matcdn.93vr.com/dehuaguan/img/mgMnv0t0PXn.jpg'],
      music: '',
      desc: ''
    },
    QFc6jIRGIs2: {
      type: 'image',
      title: '明代白釉萧',
      images: ['//matcdn.93vr.com/dehuaguan/img/QFc6jIRGIs2.jpg'],
      music: '',
      desc: ''
    },
    rG3S7Co1ewl: {
      type: 'image',
      title: '清代白釉狮形烛台',
      images: ['//matcdn.93vr.com/dehuaguan/img/rG3S7Co1ewl.jpg'],
      music: '',
      desc: ''
    },
    syu0sq2kocB: {
      type: 'image',
      title: '清代白釉送子观音',
      images: ['//matcdn.93vr.com/dehuaguan/img/syu0sq2kocB.jpg'],
      music: '',
      desc: ''
    },
    TIDlr0BSHe7: {
      type: 'image',
      title: '明代兽面双耳香炉',
      images: ['//matcdn.93vr.com/dehuaguan/img/TIDlr0BSHe7.jpg'],
      music: '',
      desc: ''
    },
    Uk71nfdWnTo: {
      type: 'image',
      title: '民国白釉镂空双耳六方瓶',
      images: ['//matcdn.93vr.com/dehuaguan/img/Uk71nfdWnTo.jpg'],
      music: '',
      desc: ''
    },
    zGGuwlBz1SQ: {
      type: 'image',
      title: '明代白釉树头杯',
      images: ['//matcdn.93vr.com/dehuaguan/img/zGGuwlBz1SQ.jpg'],
      music: '',
      desc: ''
    },
    dSsgoU5Zixz: {
      type: 'image',
      title: '明代白釉刻花碗',
      images: ['//matcdn.93vr.com/dehuaguan/img/dSsgoU5Zixz.jpg'],
      music: '',
      desc: ''
    }
  }
}
